import axios from "axios";
import { invalidateAuthSession } from "./authSessionInvalidation";
import { readAuthTokenFromStorage } from "./authSession";

const api = axios.create({
  baseURL: "/api/v1",
  headers: {
    Accept: "application/json",
  },
});

api.interceptors.request.use((config) => {
  const token = readAuthTokenFromStorage();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

function isCredentialAttemptUrl(url: string | undefined): boolean {
  if (!url) {
    return false;
  }

  return url.includes("/auth/login") || url.includes("/auth/register");
}

api.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error.response?.status;
    const requestUrl = String(error.config?.url ?? "");

    if (
      status === 401 &&
      !isCredentialAttemptUrl(requestUrl) &&
      readAuthTokenFromStorage()
    ) {
      invalidateAuthSession();
    }

    return Promise.reject(error);
  },
);

export default api;

export type ApiResponse<T> = {
  success: boolean;
  message: string;
  data: T;
};
